<template>
  <!-- A difficult section's icon: the hazard sprite's rounded triangle in the
       grade's colour (orange T3-T4, red T5-T6), white outline, white two-peak
       mountain glyph — on the sprite's 90x82 grid, so it lines up with the
       hazard icons in the same list. Decorative: the row names the grade. -->
  <svg
    class="terrain-section-icon"
    :viewBox="viewBox"
    :width="size"
    :height="height"
    aria-hidden="true"
    focusable="false"
    data-test="terrain-section-icon"
    :data-colour="colour"
  >
    <path :d="trianglePath" :fill="colour" stroke="#ffffff" stroke-width="7" stroke-linejoin="round" />
    <path :d="glyphPath" fill="#ffffff" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SAC_ORANGE, TERRAIN_GLYPH_PATH, TERRAIN_TRIANGLE_PATH, TERRAIN_VIEWBOX } from '../../../utils/routeAlerts/sacSections';

export default defineComponent({
  name: 'TerrainSectionIcon',
  props: {
    colour: { type: String, default: SAC_ORANGE },
    /** Rendered width in CSS px; the height keeps the sprite's 90:82 shape. */
    size: { type: Number, default: 36 },
  },
  data() {
    return { viewBox: TERRAIN_VIEWBOX, trianglePath: TERRAIN_TRIANGLE_PATH, glyphPath: TERRAIN_GLYPH_PATH };
  },
  computed: {
    height(): number {
      return Math.round((this.size * 82) / 90);
    },
  },
});
</script>

<style scoped>
.terrain-section-icon {
  display: block;
  flex: 0 0 auto;
}
</style>
